<div>

    <div class="dialog-headline">
        <mat-label style="float:left;">Search Vendor</mat-label>
        <mat-icon class="pointer" matTooltip="Close this dialog" mat-dialog-close style="float: right;">close</mat-icon>
    </div>

    <mat-dialog-content class="mat-typography" style="padding-top: 20px;">
        <div fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap="16px">
          <div fxFlex.gt-xs="20" fxFlex="100">
            <mat-form-field fxFlex="100">
              <mat-label>Vendor Code</mat-label>
              <input matInput [(ngModel)]="searchVendor.vendorCode" name="vendorCode" id="vendorCode"> </mat-form-field>
          </div>

          <div fxFlex.gt-xs="20" fxFlex="100">
            <mat-form-field fxFlex="100">
              <mat-label>Vendor Name</mat-label>
              <input matInput [(ngModel)]="searchVendor.vendorName" name="vendorName" id="vendorName">
            </mat-form-field>

          </div>

          <div fxLayoutAlign="end center">
            <button class="custom-blue-button" style="margin-bottom: 10px;" type="button" id="btnSearch"
              (click)="searchVendors()">
              <mat-icon color="white">search</mat-icon>Search Vendor
            </button>
          </div>
        </div>

        <form #deptSearchModalForm="ngForm" autocomplete="off">

            <div class="example-container mat-elevation-z8" *ngIf="showTableForTransactionReport">
                <div fxFlex.gt-lg="100" fxFlex.gt-md="100" fxFlex.gt-xs="100" fxFlex="100">

                    <mat-sidenav-container>

                        <mat-sidenav #sidenav position="start" mode="side" opened="false" class="width-30 p-6">
                            SIDENAV CONTENT HERE
                        </mat-sidenav>

                        <mat-sidenav-content>
                            <div class="mat-elevation-z8 m-12">
                                <div class="table-container">
                                    <!-- <table mat-table [dataSource]="dataSource"> -->
                                    <mat-table id="reportItemTable" matTableExporter matSort
                                        [dataSource]="vendorDataSource">

                                        <!-- <ng-container matColumnDef="Action">
                                            <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
                                            <mat-cell *matCellDef="let element">

                                                <button mat-icon-button matTooltip="Select {{element.description}}"
                                                    color="primary" (click)="sendSelectedDept(element)">
                                                    Select
                                                </button>

                                            </mat-cell>
                                        </ng-container> -->

                                        <ng-container color="primary" matColumnDef="Select">
                                            <mat-header-cell color="primary" *matHeaderCellDef><mat-checkbox
                                                    matTooltip="Select All" (change)="$event ? masterToggle() : null"
                                                    [checked]="selection.hasValue() && isAllSelected()"
                                                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                                                </mat-checkbox></mat-header-cell>

                                            <mat-cell color="primary" *matCellDef="let element"> <mat-checkbox
                                                    (click)="$event.stopPropagation()"
                                                    (change)="$event ? selection.toggle(element) : null"
                                                    [checked]="selection.isSelected(element)">
                                                </mat-checkbox> </mat-cell>
                                        </ng-container>




                                        <ng-container matColumnDef="vendorCode">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Code
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.vendorCode}}
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="vendorName">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>Vendor
                                                Name</mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.vendorName}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="address1">
                                            <mat-header-cell *matHeaderCellDef
                                                mat-sort-header>Address1</mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.address1}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="address2">
                                            <mat-header-cell *matHeaderCellDef
                                                mat-sort-header>Address2</mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.address2}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="city">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.city}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="cellNo">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>Cell</mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.cellNo}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="phoneOff">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>Phone</mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.phoneOff}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="emailAddress">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.emailAddress}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="salePriceUpdate">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>Sale Price
                                                Update</mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.salePriceUpdate}} </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="vendorId">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>Vendor
                                                Id</mat-header-cell>
                                            <mat-cell *matCellDef="let element"> {{element.vendorId}} </mat-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumns;"
                                            [ngClass]="{hovered: row.hovered}" (mouseover)="row.hovered = true"
                                            (mouseout)="row.hovered = false" (click)="selection.toggle(row)"></mat-row>

                                    </mat-table>


                                    <mat-paginator fxLayoutAlign="start" #paginator [length]="totalRows"
                                        [pageIndex]="currentPage" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions" aria-label="Select page"
                                        (page)="pageChanged($event)">
                                    </mat-paginator>
                                </div>
                                <!-- end table container -->

                            </div>
                        </mat-sidenav-content>

                    </mat-sidenav-container>
                </div>
            </div>


        </form>


    </mat-dialog-content>
    <!-- for adding line -->
    <hr>
    <mat-dialog-actions align="end">


        <div fxFlex.gt-lg="100" fxFlex.gt-md="100" fxFlex.gt-xs="100" fxFlex="100">
            <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100"></div>

            <div fxFlex.gt-lg="60" fxFlex.gt-md="60" fxFlex.gt-xs="100" fxFlex="100" fxLayout="row"
                fxLayoutAlign="center center" fxLayoutGap="5px">
                <button mat-dialog-close class="custom-grey-button"
                    matTooltip="Close this dialog">Close</button>

                <button class="custom-orange-button"
                    matTooltip="Send Selected Items" (click)="sendSelectedVendors()"
                    [disabled]=" selection.selected.length<1">Send Selected
                </button>

            </div>

            <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100"></div>
        </div>

    </mat-dialog-actions>
</div>
